module.exports = __webpack_public_path__ + "img/4.42e96fd7.png";